import { SxProps, Theme } from "@mui/material/styles";

/**
 * Merges any number of `sx` values into a single array that MUI applies
 * left-to-right (later entries win). `undefined` entries are skipped and
 * array-form `sx` is flattened, so a component can layer its base styles over
 * an optional forwarded `sx` prop without the usual `Array.isArray` guard:
 *
 *   sx={mergeSx({ p: 2, position: "relative" }, props.sx)}
 *   This function can't be in ig-utils as it requires MUI imports.
 */
export function mergeSx(
  ...sxs: Array<SxProps<Theme> | undefined>
): SxProps<Theme> {
  return sxs.flatMap((sx) => {
    if (!sx) return [];
    return Array.isArray(sx) ? sx : [sx];
  }) as SxProps<Theme>;
}
